/* PS AFEX S7 Final CTA */
(function () {
  if (window.__PS_AFEX_S7__) return;
  window.__PS_AFEX_S7__ = true;

  function playTick(a, b, c, d) {
    if (window.PS_AFEX && window.PS_AFEX.playTick) window.PS_AFEX.playTick(a, b, c, d);
  }

  function init() {
    var buyBtn = document.getElementById('ps-afex-buyBtn');
    if (!buyBtn) return;

    /* Headline personalisation is handled by PS_AFEX.applyPersonalization in boot.js */

    buyBtn.addEventListener('click', function () {
      playTick(600, 0.15, 'triangle', 0.07);
      var done = buyBtn.getAttribute('data-done-label') || 'Welcome to the Future ✓';
      buyBtn.textContent = done;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
